import { MenuLabel } from "../../../MenuLabel";
import Toggle from "@churchofjesuschrist/eden-toggle";

const ToggleOption = ({
    className,
    description,
    disabled,
    onToggle,
    optionId,
    title,
    toggleTitle,
    value,
}) => {
    return (
        <MenuLabel
            align={"top"}
            className={className}
            description={description}
            disabled={disabled}
            labelId={`${optionId}-toggle`}
            testId={optionId}
            title={title}
        >
            <Toggle
                data-testid={`${optionId}-toggle`}
                disabled={disabled}
                id={`${optionId}-toggle`}
                on={value}
                onToggle={onToggle}
                small
                title={toggleTitle}
            />
        </MenuLabel>
    );
};

export default ToggleOption;
